// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-central-1",
    "stage": "prod",
    "accountName": "wow",
    "api_url": "https://0yo8dafn8c.execute-api.eu-central-1.amazonaws.com/prod/graphql",
    "notifications_api_url": "https://0yo8dafn8c.execute-api.eu-central-1.amazonaws.com/prod/notifications",
    "run_daily_test_url": "https://fbcj0k0i1g.execute-api.eu-central-1.amazonaws.com/prod/run-daily-test",
    "sport_highlights_url": "https://ejmog2l2dfbvvnjtoeyyoia5ta.appsync-api.eu-central-1.amazonaws.com/graphql",
    "appconfig_url": "https://0yo8dafn8c.execute-api.eu-central-1.amazonaws.com/prod/getConfig",
    "direct_appconfig_url": "https://5v7gk3kky6.execute-api.eu-central-1.amazonaws.com/prod",
		"endpoint_url" : "https://0yo8dafn8c.execute-api.eu-central-1.amazonaws.com/prod",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_mftb1IwPv",
    "aws_user_pools_web_client_id": "4d55rdn6r45lo9t0lmeeihfm58",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.wow.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.wow.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "https://1iastuvsq3.execute-api.eu-central-1.amazonaws.com/prod",
    "arcusLicenseAcquisitionEndpointUrl": "https://xkpuhzvr07.execute-api.eu-central-1.amazonaws.com/prod"
};

export default awsConfig;

